<template>
    <DashboardLayout ref="dashboardLayout">
        <div class="flex flex-column" style="min-height: calc(100vh - 90px);">
        <Breadcrumb class="flex breadcrumb" :model="items" />
        <div class="card flex flex-column justify-center pt-4 px-4">
            <div v-if="viewStack.length > 1" class="mb-4">
                <Button label="Back" icon="pi pi-arrow-left" class="p-button-text back-button cursor-pointer "
                    @click="goBack" />
            </div>
            <div v-if="currentView.type === 'list' && (Students && Students.length)">
                <StudentList :students="Students" @view-student="pushView('profile', $event)" @open-chat="handleOpenChat" />
            </div>
            <div v-else-if="currentView.type === 'profile'">
                <StudentProfile :student="selectedStudent" @view-class="pushView('RequestClass', $event)" @open-chat="handleOpenChat" />
            </div>
            <div v-else-if="currentView.type === 'RequestClass'">
                <RequestClass :classes="classes" :modules="modules" />
            </div>
            <div v-else class="flex align-item-center justify-content-center h-full">
                <div class="flex flex-column ">
                    <span class="Caption text-gray-700 text-center"> You don’t have any Enrolled tutors yet,
                        please schedule a class with a tutor to get enrolled</span>
                </div>
            </div>
        </div>

        <!-- Notice -->
        <div v-if="currentView.type === 'list'" class="text-center w-full max-w-xl mx-auto py-4 px-6 mt-auto">
            <h3 class="text-lg font-semibold mb-2" style="color: #1FC9A3;">NOTICE</h3>
            <p class="text-700 text-sm m-0">
                If a student and tutor do not schedule any classes after enrollment, the enrollment may be automatically removed due to inactivity.
            </p>
        </div>

        </div>
    </DashboardLayout>
</template>

<script setup>
import { ref, computed, onMounted } from "vue";
import Breadcrumb from 'primevue/breadcrumb';
import Button from "primevue/button";
import StudentList from '@/components/dashboard/tutor/enrolledStudents/studentList.vue'
import StudentProfile from '@/components/dashboard/tutor/enrolledStudents/studentProfile.vue'
import RequestClass from '@/components/dashboard/tutor/classRequests/scheduleClass.vue'
import DashboardLayout from "@/layout/DashboardLayout.vue";
import { fetchEnrolledStudents } from "@/api/tutor";
import { notifyInfo } from "@/utils/notification";


const Students = ref([]);
const selectedStudent = ref([]);
// const classes = [
//     { subject: "Mathematics", classType: "Physical", location: "At Tutor’s place", classDate: "2025.04.30", classTime: "3 P.M. - 5 P.M." },
//     { subject: "Mathematics", classType: "Physical", location: "At Tutor’s place", classDate: "2025.04.30", classTime: "3 P.M. - 5 P.M." },
//     { subject: "Mathematics", classType: "Physical", location: "At Tutor’s place", classDate: "2025.04.30", classTime: "3 P.M. - 5 P.M." },
// ];

const modules = [
    "History", "English"
]
const viewStack = ref([
    { type: "list", label: "Enrolled Students", data: null }
]);
const items = computed(() => {
    return [
        { label: "Dashboard" },
        ...viewStack.value.map(v => ({ label: v.label }))
    ];
});
const currentView = computed(() =>
    viewStack.value[viewStack.value.length - 1]
);
function pushView(type, data) {
    selectedStudent.value = data;
    if (type === "profile") {
        viewStack.value.push({ type, label: data.studentName, data });
    } else {
        // viewStack.value.push({ type, label: "Request New Class", data });
        notifyInfo("Not implemented yet!")
    }
}
function goBack() {
    if (viewStack.value.length > 1) {
        viewStack.value.pop();
    }
}

const fetchStudentsEnrolled = async () => {
    const res = await fetchEnrolledStudents();
    Students.value = res.data.data;
}
onMounted(() => {
    fetchStudentsEnrolled();
})

const dashboardLayout = ref(null);

const handleOpenChat = (channel) => {
    if (dashboardLayout.value) {
        if (channel && typeof dashboardLayout.value.openSelectedChat === 'function') {
            dashboardLayout.value.openSelectedChat(channel);
        } else if (typeof dashboardLayout.value.openChatList === 'function') {
            dashboardLayout.value.openChatList();
        }
    }
}
</script>
<style scoped>
.back-button {
    color: var(--gray-600);
}

.back-button:hover {
    color: var(--gray-600) !important;
    background-color: var(--gray-200) !important;
}

.back-button:active {
    color: var(--gray-600) !important;
}

.navigation {
    display: flex !important;
    flex-wrap: wrap !important;
    display: inline-block;
    padding: 10px;
}

.breadcrumb {
    display: flex !important;
    flex-wrap: wrap !important;
    overflow-x: hidden !important;
}

.text-gray-700 {
    color: var(--gray-700) !important;
    padding-top: 30vh;
}

@media (max-width: 767px) {
    .breadcrumb {
        font-size: 12px;

    }
}
</style>